module.exports = __webpack_public_path__ + "static/img/eggbroken.5cd5d6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zjd_img/eggbroken.png
// module id = EBPh
// module chunks = 36